import { c as _c } from "react/compiler-runtime";
import { SeekButton, Tooltip } from '@vidstack/react';
import { SeekBackward10Icon, SeekForward10Icon } from '@vidstack/react/icons';
import classnames from 'classnames';
import styles from './seek-button-with-tooltip.module.scss';
export const SEEK_STEP = 10;
type SeekButtonWithTooltipProps = {
  label: string;
  type: 'backward' | 'forward';
};
export const SeekButtonWithTooltip = t0 => {
  const $ = _c(11);
  const {
    label,
    type
  } = t0;
  const isForward = type === "forward";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classnames("vds-button", styles["seek-btn"]);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isForward ? SEEK_STEP : -SEEK_STEP;
  let t3;
  if ($[1] !== isForward) {
    t3 = isForward ? <SeekForward10Icon className="vds-icon" /> : <SeekBackward10Icon className="vds-icon" />;
    $[1] = isForward;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = <Tooltip.Trigger asChild={true}><SeekButton className={t1} seconds={t2}>{t3}</SeekButton></Tooltip.Trigger>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== label) {
    t5 = <Tooltip.Content className="vds-tooltip-content" placement="top start">{label}</Tooltip.Content>;
    $[6] = label;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <Tooltip.Root>{t4}{t5}</Tooltip.Root>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};